/**
 * LanguageInitializer Component
 * Initializes language on app load and ensures HTML lang attribute is set
 */
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { updateHtmlLang, extractLanguageCode } from '../../utils/languageUtils';

const LanguageInitializer = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Update HTML lang attribute on mount
    const lang = extractLanguageCode(i18n.language);
    updateHtmlLang(lang);

    // Update HTML lang attribute when language changes
    const handleLanguageChange = (lng) => {
      const code = extractLanguageCode(lng);
      updateHtmlLang(code);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  // This component doesn't render anything
  return null;
};

export default LanguageInitializer;

